import { createSlice } from '@reduxjs/toolkit';

// Начальное значение
const initialState = {
  humidityType: undefined
};

const humidityRoomSlice = createSlice({
  name: 'humidityRoom',
  initialState,
  reducers: {
    setHumidityRoomType: (state, action) => {
      state.humidityType = action.payload;
    },
    resetHumidityRoom: (state) => initialState,
  },
});

export const { setHumidityRoomType, resetHumidityRoom } = humidityRoomSlice.actions;

export default humidityRoomSlice.reducer;